export default __webpack_public_path__ + "static/media/remainder-icon.06543f73.svg";